/**
 * @fileoverview Utility function to determine if a field will be cleared based on the current state
 * @module EntityCrud/utils/getWillBeCleared
 */

import Context from 'managers/Context';
import { getActiveCrudName } from 'utils/crud';

/**
 * Determines if a field will be cleared based on the current state and field configuration
 * @param {Object} field - The field object containing configuration and metadata
 * @param {string} field.id - The unique identifier of the field
 * @returns {Array|boolean} - Returns an array of values to be cleared if the field is an object,
 *                           or a boolean indicating if the field will be cleared
 * @throws {Error} If the field parameter is invalid or missing required properties
 */
export default (field) => {
    if (!field || typeof field !== 'object') {
        throw new Error('Field parameter must be a valid object');
    }
    if (!field.id || typeof field.id !== 'string') {
        throw new Error('Field must have a valid string id property');
    }

    const state = Context.store.getState();
    const activeCrudName = getActiveCrudName(state);

    const entityCrud = activeCrudName ? state?.entityCrud?.[activeCrudName] : {};
    const { fieldsToClear = {} } = entityCrud || {};

    const fieldClearConfig = fieldsToClear[field.id];

    if (fieldClearConfig === null || fieldClearConfig === undefined) {
        return false;
    }

    return typeof fieldClearConfig === 'object'
        ? Object.values(fieldClearConfig)
        : fieldClearConfig;
};
